function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#fff;}.cls-4{clip-path:url(#clippath);}.cls-3{fill:#4289c8;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clippath"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 589,
  height: 589
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon_-_arrows"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18329"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32429",
  className: "cls-3",
  d: "M0,294.5C0,131.85,131.85,0,294.5,0s294.5,131.85,294.5,294.5-131.85,294.5-294.5,294.5C131.93,588.81.19,457.07,0,294.5M562.37,294.5c0-147.94-119.93-267.87-267.87-267.87S26.63,146.56,26.63,294.5s119.93,267.87,267.87,267.87c147.87-.16,267.71-120,267.87-267.87"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32430",
  className: "cls-2",
  d: "M346.33,522.93l97.9-117.95c2.02-2.54,2.46-6,1.13-8.96-1.38-2.98-4.37-4.9-7.66-4.91h-40.25v-152.7c.12-6.78-5.29-12.36-12.06-12.48s-12.36,5.29-12.48,12.06v169.34c0,4.66,3.78,8.44,8.44,8.44h22.09l-63.46,76.45-63.46-76.45h22.09c4.66-.01,8.43-3.79,8.44-8.44v-209.54h40.25c3.29-.01,6.27-1.92,7.66-4.91,1.31-2.97.87-6.42-1.15-8.96l-97.9-117.95c-2.99-3.58-8.31-4.06-11.89-1.07-.39.32-.74.68-1.07,1.07l-97.87,117.8c-1.25,1.52-1.94,3.43-1.94,5.4,0,1.24.27,2.46.79,3.58,1.38,2.98,4.37,4.9,7.66,4.91h40.25v152.58c0,6.78,5.49,12.27,12.27,12.27,3.21,0,6.29-1.24,8.59-3.48,2.38-2.31,3.73-5.49,3.73-8.81v-168.58c0-4.66-3.78-8.44-8.44-8.44h-22.09l63.46-76.45,63.46,76.45h-22.09c-4.66.01-8.43,3.79-8.44,8.44v209.51h-40.25c-4.68.02-8.45,3.83-8.43,8.51,0,1.95.69,3.83,1.92,5.34l97.9,117.95c2.98,3.59,8.3,4.07,11.89,1.09.4-.33.76-.7,1.09-1.09"
}))));

function SvgIconExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 589 589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchange);
export default __webpack_public_path__ + "static/media/icon-exchange.534fdb8d.svg";
export { ForwardRef as ReactComponent };